import React from "react"
import { Button, Input } from "reactstrap"
import classNames from "classnames"
import moment from "moment"
import Reporticon from "../../../assets/images/document_accept.svg"
import Imageicon from "../../../assets/images/image_images.svg"
import projectreport from "../../../assets/images/fullreport.png"
import { isEmpty } from "lodash"
import ReportButtonProject from "./ActionButton/ReportButtonProject"

export const ExpandRowProject = props => {
  const {
    hideDateColumn,
    list,
    selectToggle,
    toggleViewModal,
    handleverifyScreen,
    onClickSubmitButton,
    setSelectedReportItem,
    onClickQuickSendToClient,
    accessgroupname,
    isDateLessThanCurrent,
    compactView,
    selectedArrayLists,
    setSelectedArrayLists,
    ExcludeNonReportFunction,
    noRowsSelected,
    isMobile,
  } = props;
  let getUnVerifiedLists = (list || []).filter(
    el =>
      el?.workReportSummary?.projectSummaryList[0]?.tasks[0]?.screenExist &&
      el?.workReportSummary?.projectSummaryList[0]?.tasks[0]?.screenVerified ===
        false
  )
  const getUnVerifiedErrorLists = (getUnVerifiedLists || []).filter(item =>
    (selectedArrayLists || []).some(ele => ele?.userId === item?.userId)
  )

  const filterVerifiedLists = (list || []).filter(
    el =>
      el?.workReportSummary?.projectSummaryList[0]?.tasks[0]?.screenVerified ||
      !el?.workReportSummary?.projectSummaryList[0]?.tasks[0]?.screenExist
  )
  // A day is "unsubmitted" when ANY of its time slots still lacks a report — not just the first
  // slot. This mirrors the desktop rule (a report is mandatory for every tracked slot) so a day
  // with an early-submitted slot plus a new empty slot is correctly flagged as incomplete.
  let getUnSubmittedLists = (filterVerifiedLists || []).filter(el =>
    (el?.workReportSummary?.projectSummaryList[0]?.tasks || []).some(
      task => task?.workReportId === 0
    )
  )
  const getErrorListsUnSubmitted = (getUnSubmittedLists || []).filter(item =>
    (selectedArrayLists || []).some(ele => ele?.userId === item?.userId)
  )

  const getOnEvaluationErrorList = (list || [])?.filter(
    el => el?.onEvaluationHours !== "00:00:00"
  )

  const FilteredUniqueNames = [
    ...new Set(
      (list || []).map(
        el => el?.workReportSummary?.projectSummaryList[0]?.workReportStatusName
      )
    ),
  ]
  const filteredArray = FilteredUniqueNames?.filter(item => item !== null)
  const splittedStatusName = filteredArray?.join(", ")

  return (
    <div>
      {list?.map((lists, idx) => (
        <table className="table mb-0 align-margin-table" key={idx}>
          <tr role="row" style={{ background: "#FEE4CA" }}>
            <td style={{}} className="padd12"></td>
            {!hideDateColumn && (
              <td
                className="padd12"
                style={{
                  width:
                    compactView == 2
                      ? hideDateColumn == false
                        ? "3%"
                        : "9%"
                      : hideDateColumn == false
                      ? "7%"
                      : "10%",
                  textAlign: "center",
                  opacity: 0,
                }}
              >
                {moment(new Date()).format("YYYY-MM-DD")}
              </td>
            )}
            <td
              id="disp-name"
              className="padd12"
              style={{
                width:
                  compactView != 2
                    ? hideDateColumn == false
                      ? "22.5%"
                      : "22%"
                    : hideDateColumn == false
                    ? "16%"
                    : "24%",
                minWidth:
                  compactView == 2
                    ? hideDateColumn == false
                      ? "230px"
                      : "180px"
                    : hideDateColumn == false
                    ? "220px"
                    : "221px",
                textAlign: "left",
                paddingLeft: "10px",
              }}
            >
              {lists.userName}
            </td>
            <td className="padd12">
              {moment(lists?.startTime).format("HH:mm:ss")}
            </td>
            <td className="padd12">
              {moment(lists?.endTime).format("HH:mm:ss ")}
            </td>
            <td
              className="padd12"
              style={{
                color: "orange",
              }}
            >
              {lists.totalHours}
            </td>
            {compactView == 2 && (
              <td
                className="padd12"
                style={{
                  textAlign: "center",
                }}
              >
                {lists.activeHours}
              </td>
            )}
            {compactView == 2 && (
              <td className="padd12">{lists.privateHours}</td>
            )}
            <td className="padd12">{lists.breakHours}</td>

            {compactView == 2 && <td className="padd12">{lists.idleHours}</td>}
            <td className="padd12">{lists.onEvaluationHours}</td>
            <td className="padd12">{lists.manualHours}</td>

            {compactView == 2 && (
              <td className="padd12">{lists.approvedHours}</td>
            )}
            {compactView == 2 && (
              <td className="padd12">{lists.rejectedHours}</td>
            )}
            <td
              style={{
                opacity: 0,
                width: compactView == 2 ? "8%" : "10%",
              }}
              className="padd12"
            >
              {lists?.workReportStatusName}
            </td>
            <td
              className="padd12"
              style={{ opacity: 0, width: compactView == 2 ? "9%" : "12%" }}
              colSpan={6}
            >
              <div className="d-flex justify-content-center">
                <span data-hover="Active Summary">
                  <img
                    src={Reporticon}
                    alt={Reporticon}
                    style={{ cursor: "pointer" }}
                  />
                </span>
                <span data-hover="Verify Screens">
                  <img
                    src={Imageicon}
                    style={{ cursor: "pointer", zIndex: "999" }}
                    alt={Imageicon}
                  />
                </span>
                <span data-hover="Verify Screens">
                  <img
                    src={projectreport}
                    alt={projectreport}
                    width={19}
                    height={19}
                    style={{ cursor: "pointer" }}
                  />
                </span>

                <span className="me-2">
                  <i className="fas fa-check"></i>
                </span>
              </div>
            </td>
          </tr>
          <tr style={{ background: "#FEE4CA" }}>
            <td
              style={{
                textAlign: "center",
                paddingBottom: "20px",
                border: "none",
              }}
            >
              <Input
                type="checkbox"
                className="form-check-Input"
                id="horizontal-customCheck"
                defaultChecked
                checked={
                  (selectedArrayLists || []).findIndex(
                    ele => lists.userId === ele.userId
                  ) > -1
                }
                onClick={e => {
                  const checkAlreadyExists = selectedArrayLists.filter(
                    ele => ele?.userId === lists?.userId
                  )
                  if (!isEmpty(checkAlreadyExists)) {
                    const FilteredLists = selectedArrayLists.filter(
                      ele => ele?.userId !== lists?.userId
                    )
                    setSelectedArrayLists(FilteredLists)
                  } else {
                    const AddedCheckedLists = [...selectedArrayLists, lists]
                    setSelectedArrayLists(AddedCheckedLists)
                  }
                }}
              />
            </td>
            <td
              colSpan={
                compactView == 2
                  ? hideDateColumn
                    ? 17
                    : 16
                  : hideDateColumn
                  ? 11
                  : 12
              }
              className="p-0 pro_mobile-table-width"
            >
              <div
                className="input-static-widthteams pre-wrap"
                style={{
                  background: "#fff",
                  marginBottom: "1.5rem",
                  minHeight: "80px",
                  marginLeft: "1rem",
                  marginRight: "1rem",
                  borderBottomWidth: "2px",
                }}
                dangerouslySetInnerHTML={{
                  __html: list?.[idx]?.items?.[0]?.reportDetail,
                }}
              />
            </td>
            <td
              className="p-0 table-tds"
              style={{
                borderBottomRightRadius: "6px",
                paddingBottom: "1rem",
                border: "none",
              }}
            >
              <div className="buttons-team-desktop">
                <span
                  className={classNames(
                    lists.items?.[0]?.workReportStatusName !== "Submitted"
                      ? "text-warning"
                      : "text-success",
                    "report-status-text text-sm mb-1"
                  )}
                >
                  {lists.items?.[0]?.workReportStatusName}
                </span>
                <Button
                  color="primary mb-2 customs-button-team"
                  onClick={e => {
                    toggleViewModal(lists)
                    setSelectedReportItem(lists)
                  }}
                >
                  View Report
                </Button>
                <Button
                  color="primary customs-button-team"
                  onClick={e => handleverifyScreen(lists)}
                >
                  View Screens
                </Button>
              </div>
            </td>
          </tr>
        </table>
      ))}
      {!selectToggle && (
        <ReportButtonProject
          getUnVerifiedErrorLists={getUnVerifiedErrorLists}
          getErrorListsUnSubmitted={getErrorListsUnSubmitted}
          getOnEvaluationErrorList={getOnEvaluationErrorList}
          noRowsSelected={noRowsSelected}
          splittedStatusName={splittedStatusName}
          accessgroupname={accessgroupname}
          classNames={classNames}
          onClickSubmitButton={onClickSubmitButton}
          selectedArrayLists={selectedArrayLists}
          onClickQuickSendToClient={onClickQuickSendToClient}
          isDateLessThanCurrent={isDateLessThanCurrent}
          setSelectedArrayLists={setSelectedArrayLists}
          ExcludeNonReportFunction={ExcludeNonReportFunction}
          list={list}
          isMobile={isMobile}
        />
      )}
    </div>
  )
}